<ul class="list-group-numbered"
  [ngbCollapse]="currentItem?.isCollapsed ?? false"
  [id]="hierarchyNodeId">
  @for (item of items; track trackFn($index, item); let i = $index) {
    <li class="d-flex flex-column">
      <div class="align-items-center flex-grow-1 ps-lg-3 nav-link py-1 align-beginning-container"
        [class.active]="item.actor.actorName === selectedActor?.actorName"
        [class.hover]="item.actor.actorName !== selectedActor?.actorName"
        [class.parent-of-selected]="item | isParentOfSelectedEntity: selectedActor"
        triggers="hover"
        [ngbTooltip]="(deploymentService.deploymentDisabledReason$(item) | async)"
        [class.ps-3]="depth === 0">
        <div class="d-flex flex-row align-items-center list-group-item flex-grow-1 align-hierarchy">
          <ng-container [ngTemplateOutlet]="actorTemplate"
            [ngTemplateOutletContext]="{$implicit: item, depth}"/>
            @if ((deploymentService.isEntityORGLoaded$(item) | async) === false) {
              @if ((deploymentService.isEntityORGLoaded$(item) | async) === false) {
                <button
                  class="pe-5 ms-3 reset-button fa-plus"
                  (dblclick)="$event.stopPropagation()"
                  (click)="loadEntityHierarchy(item); $event.stopPropagation()">
                </button>
              }
            }
            @else if (canDeployOrgOguLevels && (item | childrenOgus).length > 0) {
            <button class="pe-5 ms-3 reset-button"
              [attr.aria-label]="item.isCollapsed ? 'Expand' : 'Collapse'"
              [attr.aria-controls]="'hierarchy-control-' + item.actor.actorName"
              (dblclick)="$event.stopPropagation()"
              (click)="toggle(item); $event.stopPropagation()">
              <span
                [class.fa-chevron-down]="item.isCollapsed"
                [class.fa-chevron-up]="!item.isCollapsed">
              </span>
            </button>
          }
          @else {
          <div class="mx-4 pe-4"></div>
          <div class="pe-2"></div>
        }
      </div>
    </div>
    <ama-ng-app-store-hierarchy-list
      [actorTemplate]="actorTemplate"
      [items]="item.childrenTree"
      [currentItem]="item"
      [depth]="depth + 1"
      [hierarchyNodeId]="'hierarchy-control-' + item.actor.actorName"
      [selectedActor]="selectedActor"
      (expandEntity)="expandEntity.emit($event)"
      (collapseEntity)="collapseEntity.emit($event)"/>
    </li>
  }
</ul>
